export enum CardType {
    Activity = 'activity',
    Article = 'article',
    Case = 'case',
    Opportunity = 'opportunity',
    Pipeline = 'pipeline',
}
